export function getImg(input) {
  try {
    if (!input) {
      console.warn("🚫 getImg: caminho vazio");
      return "";
    }

    console.group("🧭 DEBUG getImg()");
    console.log("Entrada:", input);

    let path = String(input).trim();

    // 1) URLs absolutas ou data/blob -> retorna direto
    if (
      /^(https?:)?\/\//i.test(path) ||
      /^data:/i.test(path) ||
      /^blob:/i.test(path)
    ) {
      console.log("URL absoluta detectada:", path);
      console.groupEnd();
      return path;
    }

    // 2) Limpeza de prefixes comuns
    path = path
      .replace(/^@?\/?assets\//i, "")
      .replace(/^\/?public\//i, "")
      .replace(/^\/+/g, "");

    // 3) Prefixo img/
    if (!/^img\//i.test(path)) {
      if (!path.includes("/")) path = `img/${path}`;
    }

    // 4) Normaliza SOMENTE o nome do arquivo
    const parts = path.split("/");
    let filename = parts.pop();

    let name = filename;
    let ext = "";

    if (filename.includes(".")) {
      const split = filename.split(".");
      ext = split.pop().toLowerCase();
      name = split.join(".");
    }

    const normalizedName = name
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-")
      .replace(/[^A-Za-z0-9_-]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
      .toLowerCase();

    const basePath = [...parts, normalizedName].join("/");

    const allowedExts = ["webp", "png", "jpg", "jpeg"];

    // Se já veio com extensão válida → usa direto
    if (ext && allowedExts.includes(ext)) {
      const url = `/${basePath}.${ext}`;
      console.log("URL gerada:", url);

      fetch(url, { method: "HEAD" })
        .then((res) =>
          console.log(res.ok ? "✅ Imagem acessível!" : "❌ Imagem NÃO encontrada!", url)
        )
        .catch((e) =>
          console.warn("⚠️ Erro ao testar imagem:", e.message)
        );

      console.groupEnd();
      return url;
    }

    // 5) Fallback automático: tenta WEBP → PNG
    const urlWebp = `/${basePath}.webp`;
    const urlPng = `/${basePath}.png`;

    console.log("Tentando WEBP:", urlWebp);

    fetch(urlWebp, { method: "HEAD" })
      .then((res) => {
        if (res.ok) {
          console.log("✅ WEBP encontrada:", urlWebp);
          return;
        }

        console.log("❌ WEBP não encontrada, tentando PNG:", urlPng);

        return fetch(urlPng, { method: "HEAD" }).then((res2) =>
          console.log(
            res2.ok ? "✅ PNG encontrada!" : "❌ PNG também não encontrada!",
            urlPng
          )
        );
      })
      .catch((e) =>
        console.warn("⚠️ Erro ao testar imagem:", e.message)
      );

    console.groupEnd();

    // Retorna WEBP por padrão (PNG entra automaticamente no browser se existir)
    return urlWebp;
  } catch (err) {
    console.warn(`⚠️ Erro ao resolver imagem: ${input}`, err?.message);
    return "";
  }
}


// 📁 Carrega arquivos JSON da pasta /public/database
export async function getJson(filePath) {
  try {
    if (!filePath) throw new Error("Nenhum caminho informado.");

    const cleanPath = filePath
      .replace(/^\/?public\//, "")
      .replace(/^\/?database\//, "");

    const response = await fetch(`/database/${cleanPath}`);
    if (!response.ok) throw new Error(`Erro HTTP ${response.status}`);

    const data = await response.json();
    return data;
  } catch (err) {
    console.error(`❌ Erro ao carregar JSON: ${filePath}`, err.message);
    return [];
  }
}